module.exports = __webpack_public_path__ + "img/thumbnail_IndianElephant_f_albino.4bc71af9.png";